export const SET_REVIEWS_PAGE = 'SET_REVIEWS_PAGE';
export const SET_CUSTOMER_GALLERY_PAGE = 'SET_CUSTOMER_GALLERY_PAGE';
export const SET_GLOWFORGE_PRODUCTS_PAGE = 'SET_GLOWFORGE_PRODUCTS_PAGE';
export const SET_MANUAL_PAGE = 'SET_MANUAL_PAGE';



// WEBPACK FOOTER //
// ./app/actions/product.js